import React from "react";
import FlightLogoLoader from "../Components/Loader/FlightLogoLoader";
import { HOTELSRIVER_OFFICIAL_LOGO_URL as Logo } from "../utils/hotelsRiverBrandLogo";

export default function LoaderPreviewPage() {
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)",
        padding: "24px",
      }}
      dir="rtl"
    >
      <section
        style={{
          width: "min(520px, 100%)",
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: "16px",
          padding: "24px 18px",
          boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08)",
        }}
      >
        <h1
          style={{
            margin: "0 0 14px",
            fontSize: "18px",
            fontWeight: 700,
            textAlign: "center",
            color: "#0f172a",
          }}
        >
          תצוגה מקדימה: Loader מטוס
        </h1>
        <FlightLogoLoader logoSrc={Logo} logoAlt="Hotels River Logo" />
      </section>
    </main>
  );
}
